__turbopack_context__.v({
  "arrowCircle": "OriginButton-module__q6v8Mq__arrowCircle",
  "button": "OriginButton-module__q6v8Mq__button",
  "buttonContent": "OriginButton-module__q6v8Mq__buttonContent",
  "buttonGroup": "OriginButton-module__q6v8Mq__buttonGroup",
});
